import { useEffect, useState } from "react";
import api from "../../js/api";
import './UserSelect.scss';
import Button from "../Button/Button";

export default function UserSelect({ onSelect }) {

    const [users, setUsers] = useState([]);

    useEffect(() => {
        api.get('/users').then((data) => {
            setUsers(data);
        });
    }, [])

    return (
        <div id="user-select">
            <div className="flex flex-column gap user-select-list">
                {users.map((user) => (
                    <Button key={user.id} class_="user-button" onClick={() => onSelect(user)}>
                        {user.name} {' '} {user.surname} ({user.login})
                    </Button>
                ))}
            </div>
        </div>
    );
}